import React from 'react';
import { func, string } from 'prop-types';
import { GLOBAL } from '@Config/global';
import './styles.scss';

const Actions = ({ 
  onDelete = null, 
  onDownload = null, 
  onEdit = null, 
  onViewDetail = null, 
  onCustom = null, 
  customIcon = '', 
  customTitle = '', 
  content = null 
}) => {
  const { COMPONENTS_FORM: { CRUD_ACTIONS } } = GLOBAL;
  return (
    <div className={content?.length > 0 ? 'custom-actions-wrapper' : 'actions-wrapper'}>
      {onEdit && (<><button type="button" className="table-action-btn" title={CRUD_ACTIONS.UPDATE} onClick={onEdit}><i className="bi bi-pencil" /></button>&nbsp;</>)}
      {onDelete && (<><button type="button" className="table-action-btn" title={CRUD_ACTIONS.DELETE} onClick={onDelete}><i className="bi bi-trash" /></button>&nbsp;</>)}
      {onDownload && (<><button type="button" className="table-action-btn" title={CRUD_ACTIONS.CUSTOM.DOWNLOAD} onClick={onDownload}><i className="bi bi-arrow-down-circle-fill" /></button>&nbsp;</>)}
      {onViewDetail && (<><button type="button" className="table-action-btn" title={CRUD_ACTIONS.CUSTOM.VIEW_DETAIL} onClick={onViewDetail}><i className="bi bi-info-circle" /></button>&nbsp;</>)}
      {onCustom && (
        <>
          <span> {content}</span>
          <button type="button" className="table-action-btn" title={customTitle} onClick={onCustom}><i className={`bi bi-${customIcon}`} /></button>
        </>)}
    </div>
  )
}

Actions.propTypes = {
  onDelete: func,
  onDownload: func,
  onEdit: func,
  onViewDetail: func,
  onCustom: func,
  customIcon: string,
  customTitle: string
};

export default Actions;
